<template>
<m-pageframe
    title="Test: API calls and error handling"
    ref="pageframe"
>
<v-container>

<h1>Actions</h1>
<div style="padding-left: 30px; padding-bottom: 10px">
  <v-btn
        v-for="(action, index) in actions"
        v-on:click="performAction(index)"
        :key="index"
        style="margin-right: 10px; margin-top: 8px"
    >
        {{action.label}}
    </v-btn>
</div>

<div>
    <h1>Result</h1>
    <div style="padding-left: 30px; padding-bottom: 10px">
        <code style="display: block; white-space: pre;">{{response_json_pretty_print}}</code>
    </div>
</div>

<h1 style="margin-top: 15px;">Retry Tests</h1>

<div
    v-for="(item, index) in retry_responses"
    :key="index"
>
    <v-row>

        <v-col>
            <v-text-field
                label="HTTP Response Code"
                v-model="item.code"
                autocomplete="off"

            />
        </v-col>

        <v-col>
            <v-text-field
                label="Delay"
                v-model="item.delay"
                autocomplete="off"
            />
        </v-col>
    </v-row>

</div>

<v-btn
    v-on:click="onClickAddRow"
    style="margin-right: 15px;"
>
    Add
</v-btn>

<v-btn
    v-on:click="onClickTestRetry"
    color="primary"
    style="margin-right: 15px;"
>
    Test Retry Behavior
</v-btn>

<v-btn
    v-on:click="onClickTestRetrySilentNew"
    style="margin-right: 15px;"
>
    Test Silent Fail (New)
</v-btn>

<h1 style="margin-top: 15px;">Unexpected API Error Dialog</h1>

<v-btn
    v-on:click="onClickSimulateUnhandledAPIError"
>
    Simulate server does not respond
</v-btn>

<h1 style="margin-top: 15px; margin-bottom: 5px;">New style call test</h1>
<v-btn
    v-on:click="onClickWithSpinner"
    style="margin-right:15px"
>
    With Spinner
</v-btn>
<v-btn
    v-on:click="onClickWithSpinnerError"
    style="margin-right:15px"
>
    With Spinner (Error)
</v-btn>

<v-btn
    v-on:click="onClickNoSpinner"
    style="margin-right:15px"
>
    Without Spinner
</v-btn>

<v-btn
    v-on:click="onClickModernTimeout"
    style="margin-right:15px"
>
    Modern Timeout
</v-btn>


</v-container>
</m-pageframe>
</template>

<script>

export default {
    data() {
        return {
            actions: [
                { 'label': 'OK (200)', 'code' : 200 },
                { 'label': 'Unauthorized (401)', 'code' : 401 },
                { 'label': 'Internal Server Error (500)', 'code' : 500 },
                { 'label': 'Service Unavailable (503)', 'code' : 503 },
                { 'label': 'Request Timeout (408)', 'code' : 408 },
                { 'label': 'Not Found (404)', 'code' : 404 },
                { 'label': 'Front End JS ERror (420)', 'code' : 420 },
            ],

            retry_responses: [
                 {
                    'code' : 500,
                    'delay' : 20000
                },
                {
                    'code' : 500,
                    'delay' : 50
                },
            ],

            response: null,
            response_json_pretty_print: 'no response received (yet)',
        }
    },

    mounted () {
    },

    methods: {
        performAction(index)
        {
            let action = this.actions[index];

            this.$rc.makeTestAPICall(action.code, action.label, (response) => this.onResponseReceived(response) );
        },

        onResponseReceived(response)
        {
            this.response = response;
            this.response_json_pretty_print = JSON.stringify(response,null,2);
        },

        onClickAddRow()
        {
            this.retry_responses.push({
                'code' : 200,
                'delay' : 0,
            });
        },

        onClickTestRetry()
        {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/public/test/retry-test',
            
                {
                    'request_id' : this.$rc.uuidv4(),    
                    'responses': this.retry_responses,
                },
            
                (data) => {
                    this.$rc.hideSpinner();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to complete API call');
                },
            );
        },

        onClickTestRetrySilentNew()
        {
            this.$rc.rest(
                'PUT: /api/v1/public/test/retry-test',
            
                {
                    'request_id' : this.$rc.uuidv4(),    
                    'responses': this.retry_responses,
                    'axios_fail_silent': true,
                },
            
                (data) => {},
            
                () => {},
            );
        },

        onClickSimulateUnhandledAPIError()
        {
            this.$rc.testBackstopErrorHandler(
                {
                    'http_status_code' : 503,
                }
            );
        },

        onClickWithSpinner()
        {
            this.$rc.rest({
                    'spinner': true,
                    'endpoint': 'PUT: /api/v1/public/test/retry-test',
            
                    'params' : {
                            'request_id' : this.$rc.uuidv4(),  
                            'responses': [{'code': 200, 'delay': 1500}],
                        },
            
                    'on_success': (data) => {
                            this.$rc.snackbar('Complete', 1500);
                        },
            
                    'on_error': 'Unable to complete API call',
                });
        },

        onClickWithSpinnerError()
        {
            this.$rc.rest({
                    'spinner': true,
                    'endpoint': 'PUT: /api/v1/public/test/retry-test',
            
                    'params' : {
                            'request_id' : this.$rc.uuidv4(),  
                            'responses': [{'code': 400, 'delay': 1500}],
                        },
            
                    'on_success': (data) => {
                            this.$rc.snackbar('Complete', 1500);
                        },
            
                    'on_error': 'Unable to complete API call (testing errror on new style api call)',
                });
        },

        onClickNoSpinner()
        {
            this.$rc.rest({
                    'spinner': false,
                    'endpoint': 'PUT: /api/v1/public/test/retry-test',
            
                    'params' : {
                            'request_id' : this.$rc.uuidv4(),  
                            'responses': [{'code': 200, 'delay': 1500}],
                        },
            
                    'on_success': (data) => {
                            this.$rc.snackbar('Complete', 1500);
                        },
            
                    'on_error': 'Unable to complete API call',
                });
        },

        onClickModernTimeout()
        {
            this.$rc.rest({
                    'spinner': true,
                    'timeout': '1 min',
                    'endpoint': 'PUT: /api/v1/public/test/retry-test',
            
                    'params' : {
                            'request_id' : this.$rc.uuidv4(),  
                            'responses': [{'code': 200, 'delay': 15000}],
                        },
            
                    'on_success': (data) => {
                            this.$rc.snackbar('Complete', 1500);
                        },
            
                    'on_error': 'Unable to complete API call',
                });
        }
    },
}
</script>

<style lang="scss" scoped>

</style>